module.exports = __webpack_public_path__ + "static/media/erik.459a1461.gif";